import { render, staticRenderFns } from "./NavbarItemConfigV2.vue?vue&type=template&id=024da877&scoped=true"
import script from "./NavbarItemConfigV2.vue?vue&type=script&lang=js"
export * from "./NavbarItemConfigV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024da877",
  null
  
)

export default component.exports